import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient  } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Order, CaseLegalForm, OrderResponse } from '@app/_models/orders/shared';

const baseUrl = `${environment.apiUrl}/orders`;

@Injectable({ providedIn: 'root' })
export class OrderService {
  private orderSubject: BehaviorSubject<Order>;
  public order: Observable<Order>;

  public result: string;

  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.orderSubject = new BehaviorSubject<Order>(null);
    this.order = this.orderSubject.asObservable();
  }

  public get orderValue(): Order {
    return this.orderSubject.value;
  }

  saveOrder(order: Order) {
    var stored = this.getOrder();
    Object.assign(stored, order);
    sessionStorage.setItem("order", JSON.stringify(stored));
  }

  getOrder() {
      var order = new Order();
      var stored = JSON.parse(sessionStorage.getItem("order"));
      Object.assign(order, stored);
      return order;
  }

  getCaseByToken(token:string, isLegal:boolean):Observable<OrderResponse>{
    return this.http.get<OrderResponse>(`${baseUrl}/candidate?token=${encodeURIComponent(token)}&isLegal=${isLegal}`);
  }

  initiateOrder(order: Order): Observable<OrderResponse> {
    return this.http.post<OrderResponse>(`${baseUrl}/initiate-order`, order);
  }

  getCandidateComplete(token: string): Observable<OrderResponse> {
    return this.http.get<OrderResponse>(`${baseUrl}/candidate-complete?token=${encodeURIComponent(token)}`);
  }

  releaseInviteOrder(order: Order, caseID: number): Observable<OrderResponse> {
    return this.http.post<OrderResponse>(`${baseUrl}/candidate`, { 
      'currentAddress': order.currentAddress, 
      'candidate': order.candidate, 
      'previousAddresses': order.previousAddresses, 
      'previousEmployers': order.previousEmployers, 
      'education': order.education, 
      'addOnProducts' : order.addOnProducts,
      'caseID': caseID});
  }

  saveLegalForm(caseLegalForm: CaseLegalForm): Observable<any> {
    return this.http.post<any>(`${baseUrl}/save-legal-form`, caseLegalForm);
  }


  GetLegalForms( token: string): Observable<any[]> {
    return this.http.get<any>(`${baseUrl}/get-legal-forms?token=${encodeURIComponent(token)}`);
  }

  getCaseForReorder(caseID: number, directOrder: boolean): Observable<any> {
    return this.http.get<any>(`${baseUrl}/reorder?caseID=${caseID}&directOrder=${directOrder}`);
  }
}
